"use client";

import { useContext, useEffect } from "react";
import Link from "next/link";
import { NSContext } from "@/components/context/NSProvider";
import { ArchiveContext } from "@/components/context/ArchiveProvider";
import classNames from "classnames";

import { usePathname } from "next/navigation";

import * as styles from "./ShowMenu.module.css";
const ShowMenu = ({ current = false, future = false, past = false }) => {
  const { activeMenuItem, setActiveMenuItem } = useContext(NSContext);
  const { setCurrentArchiveTab } = useContext(ArchiveContext);

  const pathname = usePathname();

  const archiveClick = () => {
    setCurrentArchiveTab("all");
  };

  return (
    <div className={styles.showMenu}>
      <span className={styles.showMenuItem}>
        <Link
          className={classNames(`sub-nav-item`, {
            [styles.active]: current || future,
            [styles.inActive]: !current && !future,
          })}
          href="/show"
          onClick={() => setActiveMenuItem("show")}
          onKeyDown={() => setActiveMenuItem("show")}
        >
          CURRENT
        </Link>
      </span>
      <span className={styles.showMenuItem}>
        <Link
          className={classNames(`sub-nav-item`, {
            [styles.active]: activeMenuItem === "archive" || past,
            [styles.inActive]: activeMenuItem !== "archive" && !past,
          })}
          href="/archive"
          onClick={archiveClick}
          onKeyDown={archiveClick}
        >
          ARCHIVE
        </Link>
      </span>
    </div>
  );
};

export { ShowMenu };
